import styled from "styled-components";

export const SearchBarContainer = styled.form`
  display: flex;
  gap: 1rem;
  width: 100%;
  max-width: 720px;
  margin-bottom: 2rem;

  input {
    flex: 1;
    border: 2px solid ${(props) => props.theme["purple-500"]};
    border-radius: 8px;
    font-size: 1rem;
    padding: 0.75rem 1rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
